import { render, staticRenderFns } from "./testHome.vue?vue&type=template&id=5056083a&scoped=true"
import script from "./testHome.vue?vue&type=script&lang=js"
export * from "./testHome.vue?vue&type=script&lang=js"
import style0 from "./testHome.vue?vue&type=style&index=0&id=5056083a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056083a",
  null
  
)

export default component.exports